import CustomTable from '../../Custom/Table'
import useDescargableHistorialTable from './useDescargableTable'


const TableHistorialDescargables = ({rows}: {rows: any[]}) => {

  const { columns } = useDescargableHistorialTable()


  return (
    <CustomTable rows={rows} columns={columns} />
  )
}

export default TableHistorialDescargables